import { Button } from "@/components/Button";
import { Download } from "lucide-react";
import { useState } from "react";
import { useConfirm } from "@/hooks/useConfirm";

export function ExportButton({ filters = {} }) {
  const [isExporting, setIsExporting] = useState(false);
  const { confirm, ConfirmDialog } = useConfirm();

  const handleExport = async () => {
    setIsExporting(true);

    try {
      const params = new URLSearchParams();
      if (filters.range) params.append('range', filters.range);
      if (filters.category) params.append('category', filters.category);
      if (filters.status) params.append('status', filters.status);

      const url = `/admin/reports/redemptions/export?${params.toString()}`;

      // Crear un enlace temporal y hacer clic en él para descargar
      const link = document.createElement('a');
      link.href = url;
      link.download = `redemptions_report_${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error al exportar:', error);
      await confirm({
        title: 'Error al exportar',
        message: 'Error al exportar el reporte. Por favor intenta de nuevo.',
        confirmText: 'Entendido',
        cancelText: '',
        variant: 'danger'
      });
    } finally {
      setTimeout(() => setIsExporting(false), 1000);
    }
  };

  return (
    <>
      <Button
        onClick={handleExport}
        disabled={isExporting}
        variant="outline"
        className="border-purple-200 text-purple-600 hover:bg-purple-50"
      >
        <Download className="w-4 h-4 mr-2" />
        {isExporting ? "Exportando..." : "Exportar CSV"}
      </Button>
      <ConfirmDialog />
    </>
  );
}
